/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AlertMstCenterStockItem
 */
export interface AlertMstCenterStockItem {
    /**
     * 
     * @type {number}
     * @memberof AlertMstCenterStockItem
     */
    companyId: number | null;
    /**
     * 
     * @type {number}
     * @memberof AlertMstCenterStockItem
     */
    centerId: number | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstCenterStockItem
     */
    alertTypeName: string | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstCenterStockItem
     */
    orgCenterId: string | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstCenterStockItem
     */
    orgItemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstCenterStockItem
     */
    itemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstCenterStockItem
     */
    mstItemItemName: string | null;
    /**
     * 
     * @type {number}
     * @memberof AlertMstCenterStockItem
     */
    supplierCompanyId: number | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstCenterStockItem
     */
    supplierName: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertMstCenterStockItem
     */
    recencyFlg: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof AlertMstCenterStockItem
     */
    endDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstCenterStockItem
     */
    prevOrgItemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstCenterStockItem
     */
    nextOrgItemCode: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertMstCenterStockItem
     */
    centerTargetItemFlg: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertMstCenterStockItem
     */
    masterNotFound: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof AlertMstCenterStockItem
     */
    minRecDate: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertMstCenterStockItem
     */
    isInactive: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof AlertMstCenterStockItem
     */
    lastShipDate: Date | null;
    /**
     * 
     * @type {number}
     * @memberof AlertMstCenterStockItem
     */
    lastStockQuantity: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertMstCenterStockItem
     */
    unmatchLot: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AlertMstCenterStockItem
     */
    trCaseLot: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertMstCenterStockItem
     */
    unmatchStockdays: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AlertMstCenterStockItem
     */
    trStockDaysSetting: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertMstCenterStockItem
     */
    unmatchRenewal: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstCenterStockItem
     */
    replaceOrgItemCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstCenterStockItem
     */
    janCase: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AlertMstCenterStockItem
     */
    trStartDate: Date | null;
    /**
     * 
     * @type {number}
     * @memberof AlertMstCenterStockItem
     */
    lastShipSummary: number | null;
    /**
     * 
     * @type {number}
     * @memberof AlertMstCenterStockItem
     */
    lastShipCount: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertMstCenterStockItem
     */
    isMinShipDateAlert: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof AlertMstCenterStockItem
     */
    minShipDate: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertMstCenterStockItem
     */
    isEndSaleAlert: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof AlertMstCenterStockItem
     */
    mstItemSalesEnddate: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AlertMstCenterStockItem
     */
    salesEndAlertDate: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AlertMstCenterStockItem
     */
    alertMessage: string | null;
}

/**
 * Check if a given object implements the AlertMstCenterStockItem interface.
 */
export function instanceOfAlertMstCenterStockItem(value: object): value is AlertMstCenterStockItem {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('centerId' in value) || value['centerId'] === undefined) return false;
    if (!('alertTypeName' in value) || value['alertTypeName'] === undefined) return false;
    if (!('orgCenterId' in value) || value['orgCenterId'] === undefined) return false;
    if (!('orgItemCode' in value) || value['orgItemCode'] === undefined) return false;
    if (!('itemCode' in value) || value['itemCode'] === undefined) return false;
    if (!('mstItemItemName' in value) || value['mstItemItemName'] === undefined) return false;
    if (!('supplierCompanyId' in value) || value['supplierCompanyId'] === undefined) return false;
    if (!('supplierName' in value) || value['supplierName'] === undefined) return false;
    if (!('recencyFlg' in value) || value['recencyFlg'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('prevOrgItemCode' in value) || value['prevOrgItemCode'] === undefined) return false;
    if (!('nextOrgItemCode' in value) || value['nextOrgItemCode'] === undefined) return false;
    if (!('centerTargetItemFlg' in value) || value['centerTargetItemFlg'] === undefined) return false;
    if (!('masterNotFound' in value) || value['masterNotFound'] === undefined) return false;
    if (!('minRecDate' in value) || value['minRecDate'] === undefined) return false;
    if (!('isInactive' in value) || value['isInactive'] === undefined) return false;
    if (!('lastShipDate' in value) || value['lastShipDate'] === undefined) return false;
    if (!('lastStockQuantity' in value) || value['lastStockQuantity'] === undefined) return false;
    if (!('unmatchLot' in value) || value['unmatchLot'] === undefined) return false;
    if (!('trCaseLot' in value) || value['trCaseLot'] === undefined) return false;
    if (!('unmatchStockdays' in value) || value['unmatchStockdays'] === undefined) return false;
    if (!('trStockDaysSetting' in value) || value['trStockDaysSetting'] === undefined) return false;
    if (!('unmatchRenewal' in value) || value['unmatchRenewal'] === undefined) return false;
    if (!('replaceOrgItemCode' in value) || value['replaceOrgItemCode'] === undefined) return false;
    if (!('janCase' in value) || value['janCase'] === undefined) return false;
    if (!('trStartDate' in value) || value['trStartDate'] === undefined) return false;
    if (!('lastShipSummary' in value) || value['lastShipSummary'] === undefined) return false;
    if (!('lastShipCount' in value) || value['lastShipCount'] === undefined) return false;
    if (!('isMinShipDateAlert' in value) || value['isMinShipDateAlert'] === undefined) return false;
    if (!('minShipDate' in value) || value['minShipDate'] === undefined) return false;
    if (!('isEndSaleAlert' in value) || value['isEndSaleAlert'] === undefined) return false;
    if (!('mstItemSalesEnddate' in value) || value['mstItemSalesEnddate'] === undefined) return false;
    if (!('salesEndAlertDate' in value) || value['salesEndAlertDate'] === undefined) return false;
    if (!('alertMessage' in value) || value['alertMessage'] === undefined) return false;
    return true;
}

export function AlertMstCenterStockItemFromJSON(json: any): AlertMstCenterStockItem {
    return AlertMstCenterStockItemFromJSONTyped(json, false);
}

export function AlertMstCenterStockItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AlertMstCenterStockItem {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'centerId': json['center_id'],
        'alertTypeName': json['alert_type_name'],
        'orgCenterId': json['org_center_id'],
        'orgItemCode': json['org_item_code'],
        'itemCode': json['item_code'],
        'mstItemItemName': json['mst_item_item_name'],
        'supplierCompanyId': json['supplier_company_id'],
        'supplierName': json['supplier_name'],
        'recencyFlg': json['recency_flg'],
        'endDate': (json['end_date'] == null ? null : new Date(json['end_date'])),
        'prevOrgItemCode': json['prev_org_item_code'],
        'nextOrgItemCode': json['next_org_item_code'],
        'centerTargetItemFlg': json['center_target_item_flg'],
        'masterNotFound': json['master_not_found'],
        'minRecDate': (json['min_rec_date'] == null ? null : new Date(json['min_rec_date'])),
        'isInactive': json['is_inactive'],
        'lastShipDate': (json['last_ship_date'] == null ? null : new Date(json['last_ship_date'])),
        'lastStockQuantity': json['last_stock_quantity'],
        'unmatchLot': json['unmatch_lot'],
        'trCaseLot': json['tr_case_lot'],
        'unmatchStockdays': json['unmatch_stockdays'],
        'trStockDaysSetting': json['tr_stock_days_setting'],
        'unmatchRenewal': json['unmatch_renewal'],
        'replaceOrgItemCode': json['replace_org_item_code'],
        'janCase': json['jan_case'],
        'trStartDate': (json['tr_start_date'] == null ? null : new Date(json['tr_start_date'])),
        'lastShipSummary': json['last_ship_summary'],
        'lastShipCount': json['last_ship_count'],
        'isMinShipDateAlert': json['is_min_ship_date_alert'],
        'minShipDate': (json['min_ship_date'] == null ? null : new Date(json['min_ship_date'])),
        'isEndSaleAlert': json['is_end_sale_alert'],
        'mstItemSalesEnddate': (json['mst_item_sales_enddate'] == null ? null : new Date(json['mst_item_sales_enddate'])),
        'salesEndAlertDate': (json['sales_end_alert_date'] == null ? null : new Date(json['sales_end_alert_date'])),
        'alertMessage': json['alert_message'],
    };
}

export function AlertMstCenterStockItemToJSON(json: any): AlertMstCenterStockItem {
    return AlertMstCenterStockItemToJSONTyped(json, false);
}

export function AlertMstCenterStockItemToJSONTyped(value?: AlertMstCenterStockItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'center_id': value['centerId'],
        'alert_type_name': value['alertTypeName'],
        'org_center_id': value['orgCenterId'],
        'org_item_code': value['orgItemCode'],
        'item_code': value['itemCode'],
        'mst_item_item_name': value['mstItemItemName'],
        'supplier_company_id': value['supplierCompanyId'],
        'supplier_name': value['supplierName'],
        'recency_flg': value['recencyFlg'],
        'end_date': value['endDate'] == null ? value['endDate'] : value['endDate'].toISOString(),
        'prev_org_item_code': value['prevOrgItemCode'],
        'next_org_item_code': value['nextOrgItemCode'],
        'center_target_item_flg': value['centerTargetItemFlg'],
        'master_not_found': value['masterNotFound'],
        'min_rec_date': value['minRecDate'] == null ? value['minRecDate'] : value['minRecDate'].toISOString(),
        'is_inactive': value['isInactive'],
        'last_ship_date': value['lastShipDate'] == null ? value['lastShipDate'] : value['lastShipDate'].toISOString(),
        'last_stock_quantity': value['lastStockQuantity'],
        'unmatch_lot': value['unmatchLot'],
        'tr_case_lot': value['trCaseLot'],
        'unmatch_stockdays': value['unmatchStockdays'],
        'tr_stock_days_setting': value['trStockDaysSetting'],
        'unmatch_renewal': value['unmatchRenewal'],
        'replace_org_item_code': value['replaceOrgItemCode'],
        'jan_case': value['janCase'],
        'tr_start_date': value['trStartDate'] == null ? value['trStartDate'] : value['trStartDate'].toISOString(),
        'last_ship_summary': value['lastShipSummary'],
        'last_ship_count': value['lastShipCount'],
        'is_min_ship_date_alert': value['isMinShipDateAlert'],
        'min_ship_date': value['minShipDate'] == null ? value['minShipDate'] : value['minShipDate'].toISOString(),
        'is_end_sale_alert': value['isEndSaleAlert'],
        'mst_item_sales_enddate': value['mstItemSalesEnddate'] == null ? value['mstItemSalesEnddate'] : value['mstItemSalesEnddate'].toISOString(),
        'sales_end_alert_date': value['salesEndAlertDate'] == null ? value['salesEndAlertDate'] : value['salesEndAlertDate'].toISOString().substring(0,10),
        'alert_message': value['alertMessage'],
    };
}

